import React, { useState } from 'react';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { checkDeviceCompatibility } from '../../../store/action/OrderAction';
import { useDispatch } from 'react-redux';
import { isUndefinedNullOrEmpty } from '../../../common/common';
import { Loader } from '../../common/Loader';
import { useSessionData } from '../../../hooks/order';

const CompatibilityCheck = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { sessionResponse } = useSessionData();

  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState('');
  const [form] = Form.useForm();
  const handleSubmit = (value) => {
    const affiliateId = sessionResponse?.partnerId || '';
    let deviceBody = {
      partner: 'elnkac',
      mobileImei: value.imei,
      affiliateId,
    };
    try {
      setLoading(true);
      dispatch(checkDeviceCompatibility(deviceBody)).then(response => {
        if (response.value.data.deviceCompatibility === 'COMPATIBLE') {
          setMsg('Compatible')
          setLoading(false);
        } else {
          setMsg('Not Compatible')
          setLoading(false);
        }
      }).catch(() => {
        setMsg('Not Compatible')
        setLoading(false);

      })
    } catch (err) {
      if (!isUndefinedNullOrEmpty(err)) {
        setMsg('Not Compatible')
        setLoading(false);
      }
    }
  }

  const resultColor = () => {
    if (loading) {
      return ''
    } else {
      if (msg === 'Compatible') {
        return 'text-compatible'
      } else {
        return 'not-compatible'
      }
    }

  }

  return (
    <>
      <div className="compatible-tab-checkout same-common">
        <p>{t('compatibility.instruction')}</p>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={handleSubmit}
          form={form}>
          <Row>
            <Col span={10} className="compatible-input responsive-width-set">
              <Form.Item
                label={t('compatibility.imeiLabel')}
                name="imei"
                rules={[
                  { required: true, message: t('compatibility.imeiRequired') },
                  { min: 15, message: t('compatibility.imeiMinLength') }
                ]}
              >
                <Input
                  type="text"
                  className="input-control"
                  name="imei"
                  id="imei"
                  placeholder={t('compatibility.imeiPlaceholder')}
                  disabled={loading}
                  onChange={(e) => {
                    const value = e?.target?.value;
                    if (!isUndefinedNullOrEmpty(value)) {
                      const onlyNumber = value?.replace(/[^\d]/g, '')?.replace(' ', '')?.substring(0,17);
                      form.setFieldsValue({ imei: onlyNumber });
                    }
                    if (msg) { setMsg('') }
                  }}
                />
              </Form.Item>

              {msg ? <div className={`result-compatible ${resultColor()}`}>
                {msg === 'Compatible' ? <i className="fa-regular fa-circle-check"></i> : <i className="fa-regular fa-circle-xmark"></i>}
                <span id="resultarea">
                  {!loading && msg ? (msg === 'Compatible' ? t('compatibility.compatible') : t('compatibility.notCompatible')) : ''}
                </span>
              </div> : <></>}
            </Col>

            {loading ?
              <Loader />
              :
              <>
                {msg ?
                  <Col span={12} className="responsive-width-set check-another">
                    <>
                      <button className="blue-button" onClick={() => {
                        setMsg('')
                        form.setFieldsValue({ imei: '' })
                      }}>{t('compatibility.checkAnotherDevice')}</button>
                      <div>{t('compatibility.or')}</div>
                      <button className="blue-button grey-button" onClick={() => props.setActiveKey('3')}>{t('common.skip')}</button>
                    </>
                  </Col>
                  :
                  <Col span={8} className="responsive-width-set only-check check-another">
                    <button type="primary" htmlType="submit" className="Check blue-button">
                      {t('compatibility.submit')}
                    </button>
                    <button className="blue-button grey-button" onClick={() => props.setActiveKey('3')}>{t('common.skip')}</button>
                  </Col>
                }
              </>
            }
          </Row>
        </Form>

      </div>
    </>
  )
}
export default CompatibilityCheck;
